import {IHttpService} from "angular";
import {CodeAndExchange} from "../../../instruments/types/CodeAndExchange";
import {Moment} from "moment-timezone";
import moment from "moment";
import {IsoDate} from "../../../pseudo-types/DateTypes";
import {DateTimeUtil} from "../../../js/util/DateTimeUtil";
import {TimeSeriesPeriod} from "../types/TimeSeriesPeriod";
import {TimeSeriesRecord, TimeSeriesRecords} from "../types/TimeSeriesRecord";

declare const Papa: any;

export class TimeSeriesService {

    public static readonly id = "timeSeriesService";

    /** @ngInject */
    public constructor(private readonly $http: IHttpService) {
    }

    public async load(security: CodeAndExchange, period: TimeSeriesPeriod, adjusted = true): Promise<TimeSeriesRecords> {
        const to = moment();
        const from = this.calculateDataStart(to, period);
        const toParam = this.isoDate(to);
        const fromParam = this.isoDate(from);
        const url = `/tradefloor/api/prices/timeseries/${security.code}/${security.exchange}`;
        const params = {
            to: toParam,
            from: fromParam,
            period,
            adjusted
        };
        const response = await this.$http.post<string>(url, null, {params});
        const data = response.data;
        const csv = this.parseCsv(data);
        return this.toData(csv);
    }

    private calculateDataStart(now: Moment, period: TimeSeriesPeriod): Moment {
        switch (period) {
            case TimeSeriesPeriod.DAILY:
                return now.clone().subtract("1", "year");
            case TimeSeriesPeriod.WEEKLY:
                return now.clone().subtract("1", "year");
            case TimeSeriesPeriod.MONTHLY:
                return now.clone().subtract("5", "years");
            case TimeSeriesPeriod.QUARTERLY:
                return now.clone().subtract("10", "years");
            case TimeSeriesPeriod.YEARLY:
                return now.clone().subtract("20", "years");
        }
    }

    private isoDate(date: Moment): IsoDate {
        return date.format("YYYY-MM-DD") as IsoDate;
    }

    // TODO This is stolen from the QuoteFeedService, but there is no time to try and make it nicer right now
    private parseCsv(raw: string): ReadonlyArray<ReadonlyArray<string>> {
        const rows = Papa.parse(raw).data;
        rows.shift(); // remove the header row

        const rowHasData = (row: ReadonlyArray<string>): boolean => {
            return row != null && row.length > 0 && row[0] != null && row[0] !== "";
        };

        return rows.filter(rowHasData);
    }

    private toData(data: ReadonlyArray<ReadonlyArray<string>>): TimeSeriesRecords {
        return data.map(entry => {
            const date = DateTimeUtil.momentToIsoDate(moment(entry[0]));
            const open = parseFloat(entry[1]);
            const high = parseFloat(entry[2]);
            const low = parseFloat(entry[3]);
            const close = parseFloat(entry[4]);
            const volume = parseFloat(entry[5]);
            const value = parseFloat(entry[6]);
            const tradeCount = parseFloat(entry[7]);
            const marketVwap = parseFloat(entry[8]);
            const shortSellPosition = parseFloat(entry[9]);
            const shortSellPercent = parseFloat(entry[10]);
            const shortSold = parseFloat(entry[11]);
            const shortSoldPercent = parseFloat(entry[12]);

            return TimeSeriesRecord.of(date,
                                       open,
                                       high,
                                       low,
                                       close,
                                       volume,
                                       value,
                                       tradeCount,
                                       marketVwap,
                                       shortSellPosition,
                                       shortSellPercent,
                                       shortSold,
                                       shortSoldPercent);
        });
    }
}
